import React from "react";

export function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <div className="border-b border-neutral-200 bg-white" data-testid={testid || "page-header"}>
      <div className="px-8 py-6 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
        <div>
          {eyebrow && <div className="label-eyebrow text-neutral-500">{eyebrow}</div>}
          <h1 className="font-display font-bold tracking-tight text-3xl mt-1">{title}</h1>
          {description && <p className="text-neutral-600 mt-2 text-sm max-w-2xl">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}

export function PageBody({ children, className = "" }) {
  return <div className={`p-8 ${className}`}>{children}</div>;
}

export function StatTile({ label, value, sub, intent = "default", testid }) {
  const colors = {
    default: "text-[#0A0A0A]",
    primary: "text-[#002FA7]",
    danger: "text-[#FF3B30]",
    warning: "text-[#A57B00]",
    success: "text-[#00A040]",
  };
  return (
    <div className="border border-neutral-200 bg-white p-5" data-testid={testid}>
      <div className="label-eyebrow text-neutral-500">{label}</div>
      <div className={`font-mono text-3xl font-bold tracking-tight mt-2 ${colors[intent]}`}>{value}</div>
      {sub && <div className="text-xs text-neutral-500 mt-1">{sub}</div>}
    </div>
  );
}

export function EmptyState({ title, body, action, testid }) {
  return (
    <div className="border border-dashed border-neutral-300 bg-white p-10 text-center" data-testid={testid || "empty-state"}>
      <div className="label-eyebrow text-neutral-500">// EMPTY</div>
      <div className="font-display text-xl font-bold mt-2">{title}</div>
      {body && <p className="text-sm text-neutral-600 mt-2 max-w-md mx-auto">{body}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function StatusDot({ status }) {
  const map = {
    online: "bg-[#00C853]",
    offline: "bg-neutral-400",
    warning: "bg-[#FFCC00]",
    alert: "bg-[#FF3B30]",
  };
  return <span className={`inline-block w-2 h-2 rounded-full ${map[status] || "bg-neutral-300"}`} />;
}
